// before 20-5-2026

// components/TeamLeaderAssignLeadsDialog.js
// import React, { useState, useEffect, useRef } from 'react';
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Button,
//   Box,
//   Typography,
//   CircularProgress,
//   Checkbox,
//   FormControlLabel,
//   Radio,
//   RadioGroup,
//   FormLabel,
//   Autocomplete,
//   TextField,
//   Alert,
//   Divider,
//   Chip,
//   IconButton,
//   Tooltip,
//   Paper,
//   Grid,
//   useTheme,
// } from '@mui/material';
// import CloseIcon from '@mui/icons-material/Close';
// import SendIcon from '@mui/icons-material/Send';
// import PersonIcon from '@mui/icons-material/Person';
// import EmailIcon from '@mui/icons-material/Email';
// import PhoneIcon from '@mui/icons-material/Phone';
// import { useDispatch, useSelector } from 'react-redux';
// import { Notify } from '../Utility/Notify';
// import { AssignleadsinteamleaderAction } from '../Redux/Actions/UsersAction';
// import { Get_All_Sales_By_TeamLeader_Email_Action } from '../Redux/Actions/SalesAction';
// import { GetAll_stage_Data } from '../Redux/Actions/Stage_Action';

// // نفس الـ chunkArray function
// const chunkArray = (array, size) => {
//   const chunked = [];
//   for (let i = 0; i < array.length; i += size) {
//     chunked.push(array.slice(i, i + size));
//   }
//   return chunked;
// };

// export const TeamLeaderAssignLeadsDialog = ({
//   open,
//   onClose,
//   teamLeaderInfo,
//   refreshData,
//   currentSales = null,
// }) => {
//   const theme = useTheme();
//   const mode = theme.palette.mode;
//   const dispatch = useDispatch();

//   // States - استخدام useRef للـ leadsall بدل useState
//   const leadsallRef = useRef([]);
//   const [leadsallLength, setLeadsallLength] = useState(0);

//   const [salesname, setSalesname] = useState('');
//   const [selectedSales, setSelectedSales] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [sendloading, setSendloading] = useState(false);
//   const [clearHistory, setClearHistory] = useState(false);

//   // States للـ Stages
//   const [selectedOption, setSelectedOption] = useState('option1');
//   const [selectedStage, setSelectedStage] = useState(null);
//   const [localStages, setLocalStages] = useState([]);

//   const [userlogin, setUserlogin] = useState(null);

//   // جلب بيانات الـ Sales
//   const resSalesData = useSelector((state) => state.AllSales.salesforteamleaders);

//   // جلب بيانات الـ Stages
//   const resStagesData = useSelector((state) => state.Allstages.stage?.data || []);

//   // جلب بيانات الـ assigned leads
//   const resAssignedData = useSelector((state) => state.AllLead_Assigned.Lead_Assigned);
//   const resAllassignedLeadArray = Array.isArray(resAssignedData?.data) ? resAssignedData.data : [];

//   // 🔥 تحميل بيانات المستخدم
//   useEffect(() => {
//     const user = JSON.parse(localStorage.getItem('user'));
//     if (user) {
//       setUserlogin(user);
//     }
//   }, []);

//   // 🔥 تحميل الـ leads من localStorage فقط عند فتح الدايلوج
//   useEffect(() => {
//     if (open) {
//       const storedLeads = localStorage.getItem('selectedleedsbyteamleader');
//       if (storedLeads) {
//         try {
//           const parsedLeads = JSON.parse(storedLeads);
//           leadsallRef.current = parsedLeads;
//           setLeadsallLength(parsedLeads.length);
//           console.log('📌 Loaded leads from localStorage:', parsedLeads.length);
//         } catch (error) {
//           console.error('Error parsing leads from localStorage:', error);
//           leadsallRef.current = [];
//           setLeadsallLength(0);
//         }
//       } else {
//         leadsallRef.current = [];
//         setLeadsallLength(0);
//       }
//     }
//   }, [open]);

//   // 🔥 الحل: تحميل الـ Sales عند فتح الدايلوج
//   useEffect(() => {
//     if (open && userlogin?.data?.email) {
//       console.log('🔍 Loading sales for team leader:', userlogin?.data?.email);
//       dispatch(Get_All_Sales_By_TeamLeader_Email_Action(userlogin?.data?.email));
//     }
//   }, [open, userlogin?.data?.email, dispatch]);

//   // 🔥 تحميل الـ Stages
//   useEffect(() => {
//     if (open) {
//       console.log('📊 Loading stages...');
//       dispatch(GetAll_stage_Data());
//     }
//   }, [open, dispatch]);

//   // 🔥 معالجة بيانات الـ Stages
//   useEffect(() => {
//     if (Array.isArray(resStagesData) && resStagesData.length > 0) {
//       console.log('✅ Stages loaded:', resStagesData.length);
//       setLocalStages(resStagesData);
//     }
//   }, [resStagesData]);

//   // 🔥 تحويل بيانات الـ Sales للاستخدام
//   const salsedata = resSalesData?.data || [];

//   // 🔥 فلترة الـ Sales (شيل الـ Team Leader نفسه)
//   const filteredSalesData = salsedata.filter(
//     (sales) => sales?.userlog?.name !== userlogin?.data?.name,
//   );

//   console.log('📈 Sales data available:', filteredSalesData.length);

//   // 🔥 دالة الإرسال مع الـ Stages
//   const handleAssign = async (e) => {
//     e?.preventDefault();

//     if (!salesname) {
//       Notify('error', 'Please select sales', 'error');
//       return;
//     }

//     if (leadsallRef.current.length === 0) {
//       Notify('error', 'No leads selected', 'error');
//       return;
//     }

//     setLoading(true);
//     setSendloading(true);

//     try {
//       // تحضير بيانات التحديث
//       const updateDataTemplate = {
//         sales: salesname,
//       };

//       // 🔥 إضافة الـ stage لو المستخدم اختار Change Stage
//       if (selectedOption === 'option2' && selectedStage?.value) {
//         updateDataTemplate.stage = selectedStage.value;
//         console.log('🎯 Stage selected for update:', selectedStage.value);
//       }

//       // تقسيم الـ leads
//       const leadChunks = chunkArray(leadsallRef.current, 10);

//       // إرسال البيانات
//       for (const chunk of leadChunks) {
//         await Promise.all(
//           chunk.map(
//             async (leadId) =>
//               await dispatch(
//                 AssignleadsinteamleaderAction(
//                   leadId,
//                   userlogin?.data?._id,
//                   salesname,
//                   clearHistory,
//                   updateDataTemplate.stage,
//                 ),
//               ),
//           ),
//         );
//       }

//       Notify('success', `Successfully assigned ${leadsallRef.current.length} lead(s)`, 'success');

//       // مسح الـ leads من localStorage بعد الإرسال الناجح
//       localStorage.removeItem('selectedleedsbyteamleader');

//       // تحديث البيانات
//       if (refreshData) {
//         refreshData();
//       }

//       // تنظيف وإغلاق
//       setSalesname('');
//       setSelectedSales(null);
//       setClearHistory(false);
//       setSelectedOption('option1');
//       setSelectedStage(null);
//       leadsallRef.current = [];
//       setLeadsallLength(0);

//       // إغلاق الدايلوج مع تأخير
//       setTimeout(() => {
//         onClose();
//       }, 500);
//     } catch (error) {
//       Notify('error', 'Failed to assign leads', 'error');
//       console.error('❌ Error assigning leads:', error);
//     } finally {
//       setLoading(false);
//       setSendloading(false);
//     }
//   };

//   // 🔥 تغيير الـ Sales - بدون إحداث re-render كبير
//   const handleSalesChange = (event) => {
//     const selectedId = event.target.value;
//     setSalesname(selectedId);

//     const sales = filteredSalesData.find((s) => s._id === selectedId);
//     setSelectedSales(sales);
//     console.log('👤 Sales selected:', sales?.name);
//   };

//   // 🔥 تغيير الـ Stage - بدون إحداث re-render كبير
//   const handleStageChange = (event, newValue) => {
//     setSelectedStage(newValue);
//     console.log('🎯 Stage selected:', newValue?.label);
//   };

//   // 🔥 تحقق إذا كان الـ Sales تم تعيينه مسبقاً
//   const isSalesAssigned = (salesId) => {
//     if (leadsallRef.current.length > 1) return false;
//     return resAllassignedLeadArray.some((item) =>
//       item.Assigned_to ? item.Assigned_to._id === salesId : null,
//     );
//   };

//   // 🔥 تحضير خيارات الـ Stages للـ Autocomplete
//   const stageOptions = Array.isArray(localStages)
//     ? localStages
//         .filter((item) => item.name?.toLowerCase() !== 'fresh')
//         .map((item) => ({
//           label: item.name?.toLowerCase() === 'no stage' ? 'Fresh' : item.name || '',
//           value: item._id || '',
//         }))
//     : [];

//   return (
//     <Dialog
//       open={open}
//       onClose={!loading ? onClose : null}
//       maxWidth="md"
//       fullWidth
//       PaperProps={{
//         sx: {
//           borderRadius: 2,
//           background:
//             mode === 'dark'
//               ? 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)'
//               : 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
//           border: '1px solid',
//           borderColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
//           boxShadow:
//             mode === 'dark' ? '0 20px 60px rgba(0,0,0,0.5)' : '0 20px 60px rgba(0,0,0,0.1)',
//         },
//       }}
//     >
//       {/* Header */}
//       <DialogTitle
//         sx={{
//           display: 'flex',
//           justifyContent: 'space-between',
//           alignItems: 'center',
//           bgcolor: mode === 'dark' ? '#1e293b' : '#102dff',
//           color: 'white',
//           py: 2,
//           px: 3,
//           position: 'relative',
//           overflow: 'hidden',
//         }}
//       >
//         <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, zIndex: 1 }}>
//           <Box
//             sx={{
//               width: 40,
//               height: 40,
//               borderRadius: '50%',
//               background: 'rgba(255,255,255,0.2)',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//             }}
//           >
//             <SendIcon sx={{ color: 'white' }} />
//           </Box>
//           <Box>
//             <Typography variant="h6" fontWeight="bold">
//               📤 Assign Leads to Sales
//             </Typography>
//             <Typography variant="caption" sx={{ opacity: 0.9, display: 'block' }}>
//               {leadsallLength} lead(s) selected
//             </Typography>
//           </Box>
//         </Box>

//         <IconButton
//           onClick={!loading ? onClose : null}
//           disabled={loading}
//           sx={{
//             color: 'white',
//             '&:hover': {
//               backgroundColor: 'rgba(255,255,255,0.2)',
//               transform: 'rotate(90deg)',
//               transition: 'transform 0.3s ease',
//             },
//           }}
//         >
//           <CloseIcon />
//         </IconButton>

//         {/* تأثير خلفي */}
//         <Box
//           sx={{
//             position: 'absolute',
//             top: 0,
//             left: 0,
//             right: 0,
//             height: '3px',
//             background: 'linear-gradient(90deg, #4caf50, #2196f3, #9c27b0)',
//             backgroundSize: '200% 100%',
//             animation: 'shimmer 2s infinite linear',
//           }}
//         />
//       </DialogTitle>

//       <DialogContent sx={{ p: 3 }}>
//         {/* Leads Summary */}
//         <Paper
//           style={{ marginTop: '10px' }}
//           elevation={0}
//           sx={{
//             p: 2.5,
//             mb: 3,
//             background: mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(16, 45, 255, 0.05)',
//             borderRadius: 2,
//             border: '1px solid',
//             borderColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(16, 45, 255, 0.1)',
//           }}
//         >
//           <Typography
//             variant="subtitle2"
//             gutterBottom
//             sx={{
//               color: mode === 'dark' ? '#fff' : '#333',
//               fontWeight: '600',
//             }}
//           >
//             📋 Selected Leads Summary
//           </Typography>

//           <Grid container spacing={1}>
//             <Grid item xs={6}>
//               <Typography variant="caption" color="text.secondary">
//                 Total Leads
//               </Typography>
//               <Typography variant="h6" fontWeight="bold" color="primary">
//                 {leadsallLength}
//               </Typography>
//             </Grid>
//             <Grid item xs={6}>
//               <Typography variant="caption" color="text.secondary">
//                 Assigning From
//               </Typography>
//               <Typography variant="body2" fontWeight="medium">
//                 {userlogin?.data?.name || 'Team Leader'}
//               </Typography>
//             </Grid>
//           </Grid>
//         </Paper>

//         {/* Step 1: Select Sales */}
//         <Box sx={{ mb: 3 }}>
//           <Typography
//             variant="subtitle1"
//             gutterBottom
//             sx={{
//               color: mode === 'dark' ? '#fff' : '#333',
//               fontWeight: '600',
//               display: 'flex',
//               alignItems: 'center',
//               gap: 1,
//             }}
//           >
//             <PersonIcon fontSize="small" /> 1. Choose Sales
//           </Typography>

//           {filteredSalesData.length === 0 ? (
//             <Alert
//               severity="info"
//               sx={{
//                 borderRadius: '8px',
//                 backgroundColor:
//                   mode === 'dark' ? 'rgba(33, 150, 243, 0.1)' : 'rgba(33, 150, 243, 0.05)',
//               }}
//             >
//               <Typography variant="body2">
//                 Loading sales team... {resSalesData?.loading ? '(Loading...)' : '(No sales found)'}
//               </Typography>
//             </Alert>
//           ) : (
//             <FormControl
//               fullWidth
//               sx={{
//                 mt: 1,
//                 '& .MuiInputBase-root': {
//                   backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
//                   borderRadius: '8px',
//                 },
//               }}
//             >
//               <InputLabel id="select-label-Sales">Choose Sales</InputLabel>
//               <Select
//                 labelId="select-label-Sales"
//                 value={salesname}
//                 onChange={handleSalesChange}
//                 label="Choose Sales"
//                 disabled={loading}
//               >
//                 {filteredSalesData.map((sales) => {
//                   const isAssigned = isSalesAssigned(sales._id);

//                   return (
//                     <MenuItem
//                       key={sales._id}
//                       value={sales._id}
//                       sx={{
//                         background:
//                           leadsallLength === 1 && isAssigned
//                             ? mode === 'dark'
//                               ? 'rgba(76, 175, 80, 0.2)'
//                               : 'rgba(76, 175, 80, 0.1)'
//                             : 'transparent',
//                         borderLeft:
//                           leadsallLength === 1 && isAssigned ? '4px solid #4caf50' : 'none',
//                         color: mode === 'dark' ? '#fff' : '#333',
//                       }}
//                     >
//                       <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, width: '100%' }}>
//                         <Box
//                           sx={{
//                             width: 8,
//                             height: 8,
//                             borderRadius: '50%',
//                             backgroundColor: '#4caf50',
//                           }}
//                         />

//                         <Box sx={{ flex: 1 }}>
//                           <Typography variant="body2" fontWeight="medium">
//                             {sales.name}
//                           </Typography>
//                           <Typography
//                             variant="caption"
//                             sx={{
//                               color: mode === 'dark' ? 'rgba(255,255,255,0.6)' : 'rgba(0,0,0,0.6)',
//                               display: 'block',
//                             }}
//                           >
//                             {sales.userlog?.email || sales.email || 'No email'}
//                           </Typography>
//                         </Box>
//                       </Box>
//                     </MenuItem>
//                   );
//                 })}
//               </Select>
//             </FormControl>
//           )}

//           {selectedSales && (
//             <Alert
//               severity="info"
//               sx={{
//                 mt: 2,
//                 borderRadius: '8px',
//                 backgroundColor:
//                   mode === 'dark' ? 'rgba(33, 150, 243, 0.1)' : 'rgba(33, 150, 243, 0.05)',
//               }}
//             >
//               <Typography variant="body2" fontWeight="medium">
//                 📧 {selectedSales.name} • {selectedSales.userlog?.email || selectedSales.email}
//               </Typography>
//             </Alert>
//           )}
//         </Box>

//         <Divider sx={{ my: 2 }} />

//         {/* 🔥 Step 2: Stage Options */}
//         <Box sx={{ mb: 3 }}>
//           <Typography
//             variant="subtitle1"
//             gutterBottom
//             sx={{
//               color: mode === 'dark' ? '#fff' : '#333',
//               fontWeight: '600',
//             }}
//           >
//             2. Stage Options
//           </Typography>

//           <div className="d-flex justify-content-start w-100 flex-wrap gap-3 mb-3">
//             <label className={`radio-box ${selectedOption === 'option1' ? 'active' : ''}`}>
//               <input
//                 type="radio"
//                 name="customRadio"
//                 value="option1"
//                 checked={selectedOption === 'option1'}
//                 onChange={(e) => setSelectedOption(e.target.value)}
//                 disabled={loading}
//               />
//               <span>Same Stage</span>
//             </label>

//             <label className={`radio-box ${selectedOption === 'option2' ? 'active' : ''}`}>
//               <input
//                 type="radio"
//                 name="customRadio"
//                 value="option2"
//                 checked={selectedOption === 'option2'}
//                 onChange={(e) => setSelectedOption(e.target.value)}
//                 disabled={loading}
//               />
//               <span>Change Stage</span>
//             </label>
//           </div>

//           {/* ✅ Autocomplete للـ Stages */}
//           {selectedOption === 'option2' && (
//             <div className="d-flex justify-content-start w-100 mb-3">
//               <div style={{ width: '100%' }}>
//                 <Autocomplete
//                   options={stageOptions}
//                   loading={resStagesData.length === 0}
//                   getOptionLabel={(option) => option?.label || ''}
//                   value={selectedStage}
//                   onChange={handleStageChange}
//                   disabled={loading}
//                   renderInput={(params) => (
//                     <TextField
//                       {...params}
//                       label="Select Stage"
//                       variant="outlined"
//                       placeholder={
//                         resStagesData.length === 0 ? 'Loading stages...' : 'Choose Stage'
//                       }
//                       size="small"
//                       sx={{
//                         '& .MuiInputBase-root': {
//                           backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
//                           borderRadius: '8px',
//                         },
//                         '& .MuiOutlinedInput-notchedOutline': {
//                           borderColor:
//                             mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)',
//                         },
//                         '&:hover .MuiOutlinedInput-notchedOutline': {
//                           borderColor: '#102dff',
//                         },
//                         '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
//                           borderColor: '#102dff',
//                         },
//                       }}
//                     />
//                   )}
//                 />
//               </div>
//             </div>
//           )}

//           {/* CSS للـ Radio Boxes */}
//           <style>{`
//             .radio-box {
//               display: flex;
//               align-items: center;
//               justify-content: center;
//               border: 2px solid ${mode === 'dark' ? 'rgba(255,255,255,0.2)' : '#ccc'};
//               border-radius: 10px;
//               padding: 12px 24px;
//               cursor: pointer;
//               transition: all 0.3s ease;
//               min-width: 120px;
//               text-align: center;
//               position: relative;
//               font-weight: 500;
//               background-color: ${mode === 'dark' ? '#2d2d2d' : '#fff'};
//               color: ${mode === 'dark' ? '#fff' : '#333'};
//             }

//             .radio-box input {
//               display: none;
//             }

//             .radio-box.active {
//               border-color: #102dff;
//               background-color: #102dff;
//               color: white;
//             }

//             .radio-box:hover:not(.active) {
//               border-color: #102dff;
//             }
            
//             .radio-box input:disabled + span {
//               opacity: 0.5;
//               cursor: not-allowed;
//             }
//           `}</style>
//         </Box>

//         <Divider sx={{ my: 2 }} />

//         {/* Step 3: Clear History Option */}
//         <Box sx={{ mb: 3 }}>
//           <Typography
//             variant="subtitle1"
//             gutterBottom
//             sx={{
//               color: mode === 'dark' ? '#fff' : '#333',
//               fontWeight: '600',
//             }}
//           >
//             3. Additional Options
//           </Typography>

//           <Box display="flex" alignItems="center" sx={{ gap: '10px' }}>
//             <label
//               htmlFor="clear-history-dialog"
//               style={{
//                 position: 'relative',
//                 cursor: loading ? 'not-allowed' : 'pointer',
//                 display: 'flex',
//                 alignItems: 'center',
//               }}
//             >
//               <input
//                 type="checkbox"
//                 id="clear-history-dialog"
//                 checked={clearHistory}
//                 onChange={(e) => setClearHistory(e.target.checked)}
//                 disabled={loading}
//                 style={{
//                   position: 'absolute',
//                   opacity: 0,
//                   height: 0,
//                   width: 0,
//                 }}
//               />
//               <span
//                 style={{
//                   display: 'inline-block',
//                   width: '20px',
//                   height: '20px',
//                   border: '2px solid #2196F3',
//                   borderRadius: '4px',
//                   transition: 'all 0.3s',
//                   position: 'relative',
//                   background: clearHistory ? '#2196F3' : 'transparent',
//                   opacity: loading ? 0.5 : 1,
//                 }}
//               >
//                 {clearHistory && (
//                   <span
//                     style={{
//                       position: 'absolute',
//                       left: '50%',
//                       top: '50%',
//                       transform: 'translate(-50%, -50%)',
//                       width: '12px',
//                       height: '12px',
//                       background: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='white'%3E%3Cpath d='M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z'/%3E%3C/svg%3E")`,
//                     }}
//                   />
//                 )}
//               </span>
//             </label>

//             <label
//               htmlFor="clear-history-dialog"
//               style={{
//                 cursor: loading ? 'not-allowed' : 'pointer',
//                 userSelect: 'none',
//                 fontSize: '15px',
//                 color: mode === 'dark' ? 'rgba(255,255,255,0.9)' : '#333',
//                 fontWeight: '500',
//                 opacity: loading ? 0.5 : 1,
//               }}
//             >
//               Clear previous comments for this sales
//             </label>
//           </Box>
//         </Box>

//         {/* Warning Message */}
//         {leadsallLength > 0 && (
//           <Alert
//             severity="warning"
//             sx={{
//               mt: 2,
//               borderRadius: '8px',
//               backgroundColor:
//                 mode === 'dark' ? 'rgba(255, 193, 7, 0.1)' : 'rgba(255, 193, 7, 0.05)',
//             }}
//           >
//             <Typography variant="body2">
//               ⚠️ You are assigning <strong>{leadsallLength}</strong> lead(s).
//               {selectedOption === 'option2' && selectedStage && (
//                 <span>
//                   {' '}
//                   All leads will be moved to <strong>{selectedStage.label}</strong> stage.
//                 </span>
//               )}
//             </Typography>
//           </Alert>
//         )}
//       </DialogContent>

//       {/* Footer */}
//       <DialogActions
//         sx={{
//           p: 3,
//           pt: 0,
//           borderTop: '1px solid',
//           borderColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
//         }}
//       >
//         <Button
//           onClick={onClose}
//           variant="outlined"
//           disabled={loading}
//           sx={{
//             color: mode === 'dark' ? '#fff' : '#666',
//             borderColor: mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
//             '&:hover': {
//               borderColor: mode === 'dark' ? '#fff' : '#000',
//             },
//             minWidth: 100,
//             py: 1,
//             borderRadius: '8px',
//           }}
//         >
//           Cancel
//         </Button>

//         <Button
//           onClick={handleAssign}
//           variant="contained"
//           startIcon={sendloading ? <CircularProgress size={20} color="inherit" /> : <SendIcon />}
//           disabled={!salesname || sendloading || leadsallLength === 0}
//           sx={{
//             background: sendloading ? '#888' : salesname ? '#102dff' : 'rgba(16, 45, 255, 0.5)',
//             color: 'white',
//             minWidth: 160,
//             py: 1,
//             borderRadius: '8px',
//             fontWeight: 'bold',
//             '&:hover': {
//               background: salesname ? '#0a25d9' : 'rgba(16, 45, 255, 0.5)',
//               transform: salesname ? 'translateY(-1px)' : 'none',
//               boxShadow: salesname ? '0 4px 12px rgba(16, 45, 255, 0.3)' : 'none',
//             },
//           }}
//         >
//           {sendloading ? 'Processing...' : `Assign (${leadsallLength})`}
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };















// 20-5-2026

import React, { useState, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Notify } from '../Utility/Notify';
import { AssignleadsinteamleaderAction } from '../Redux/Actions/UsersAction';
import { Get_All_Sales_By_TeamLeader_Email_Action } from '../Redux/Actions/SalesAction';
import { GetAll_stage_Data } from '../Redux/Actions/Stage_Action';

/* ─── helpers ─────────────────────────────────────────────────────────────── */
const chunkArray = (array, size) => {
  const chunked = [];
  for (let i = 0; i < array.length; i += size) chunked.push(array.slice(i, i + size));
  return chunked;
};

const getInitials = (name = '') =>
  name.split(' ').filter(Boolean).map(w => w[0]).join('').toUpperCase().slice(0, 2) || '?';

const avatarBg = (name = '') => {
  const colors = ['#C7D2FE','#FDE68A','#A7F3D0','#FBCFE8','#BAE6FD','#DDD6FE','#FED7AA','#D1FAE5','#E0E7FF','#FCE7F3'];
  let h = 0;
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) % colors.length;
  return colors[h];
};
const avatarFg = (name = '') => {
  const colors = ['#4338CA','#92400E','#065F46','#9D174D','#075985','#5B21B6','#92400E','#064E3B','#312E81','#831843'];
  let h = 0;
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) % colors.length;
  return colors[h];
};

/* ─── CSS — identical tokens to AssignLeadsModal ─────────────────────────── */
const STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&display=swap');

  @keyframes tla-in  { from{opacity:0;transform:translateY(20px) scale(0.97)} to{opacity:1;transform:none} }
  @keyframes tla-spin { to{transform:rotate(360deg)} }

  .tla-overlay {
    position:fixed; inset:0; z-index:99999;
    display:flex; align-items:center; justify-content:center;
    background:rgba(15,20,40,0.55); backdrop-filter:blur(6px);
    padding:16px; font-family:'DM Sans',sans-serif;
  }
  .tla-modal {
    background:#fff; border-radius:20px;
    width:100%; max-width:640px; max-height:90vh;
    overflow:hidden; display:flex; flex-direction:column;
    box-shadow:0 24px 64px rgba(0,0,0,0.18);
    animation:tla-in 0.28s cubic-bezier(0.34,1.2,0.64,1) both;
  }

  /* header */
  .tla-header { padding:24px 28px 16px; border-bottom:1px solid #F1F3F9; flex-shrink:0; }
  .tla-header-top { display:flex; align-items:flex-start; justify-content:space-between; }
  .tla-title { font-size:22px; font-weight:700; color:#0F172A; margin:0 0 6px; letter-spacing:-0.3px; }
  .tla-subtitle { display:flex; align-items:center; gap:6px; font-size:13px; color:#64748B; font-weight:500; }
  .tla-subtitle-dot { width:8px; height:8px; border-radius:50%; background:#1E40AF; flex-shrink:0; }
  .tla-close {
    width:34px; height:34px; border-radius:50%;
    border:1.5px solid #E2E8F0; background:#F8FAFC;
    display:flex; align-items:center; justify-content:center;
    cursor:pointer; color:#64748B; flex-shrink:0; transition:all 0.15s;
  }
  .tla-close:hover { background:#F1F5F9; color:#0F172A; border-color:#CBD5E1; }

  /* body */
  .tla-body {
    flex:1; overflow-y:auto; padding:24px 28px;
    scrollbar-width:thin; scrollbar-color:#CBD5E1 transparent;
  }
  .tla-body::-webkit-scrollbar { width:5px; }
  .tla-body::-webkit-scrollbar-thumb { background:#CBD5E1; border-radius:999px; }

  /* section label */
  .tla-section-label {
    font-size:11px; font-weight:700; letter-spacing:0.1em;
    color:#94A3B8; text-transform:uppercase; margin:0 0 14px;
  }

  /* summary banner */
  .tla-summary {
    display:flex; align-items:center; gap:16px;
    background:#EFF6FF; border:1px solid #BFDBFE;
    border-radius:14px; padding:18px 20px; margin-bottom:28px;
  }
  .tla-summary-icon {
    width:44px; height:44px; border-radius:12px;
    background:#DBEAFE; display:flex; align-items:center; justify-content:center; flex-shrink:0;
  }
  .tla-summary-count { font-size:26px; font-weight:700; color:#1E40AF; line-height:1; }
  .tla-summary-label { font-size:12px; color:#64748B; margin-top:2px; }
  .tla-summary-from { font-size:13px; color:#0F172A; font-weight:600; }
  .tla-summary-from-label { font-size:11px; color:#94A3B8; }

  /* search */
  .tla-search-wrap { position:relative; margin-bottom:12px; }
  .tla-search-input {
    width:100%; padding:14px 44px 14px 44px;
    border:1.5px solid #E2E8F0; border-radius:12px;
    font-family:'DM Sans',sans-serif; font-size:14px; color:#0F172A;
    background:#F8FAFC; outline:none; transition:border-color 0.15s; box-sizing:border-box;
  }
  .tla-search-input:focus { border-color:#1E40AF; background:#fff; }
  .tla-search-input::placeholder { color:#94A3B8; }
  .tla-search-icon { position:absolute; left:14px; top:50%; transform:translateY(-50%); color:#94A3B8; pointer-events:none; }
  .tla-search-arrow { position:absolute; right:14px; top:50%; transform:translateY(-50%); color:#94A3B8; pointer-events:none; }

  /* sales list */
  .tla-sales-list {
    border:1.5px solid #E2E8F0; border-radius:12px;
    overflow:hidden; margin-bottom:28px; max-height:220px; overflow-y:auto;
    scrollbar-width:thin; scrollbar-color:#CBD5E1 transparent;
  }
  .tla-sales-list::-webkit-scrollbar { width:4px; }
  .tla-sales-list::-webkit-scrollbar-thumb { background:#CBD5E1; border-radius:4px; }
  .tla-sales-item {
    display:flex; align-items:center; gap:12px;
    padding:14px 16px; cursor:pointer; transition:background 0.12s;
    border-bottom:1px solid #F1F3F9;
  }
  .tla-sales-item:last-child { border-bottom:none; }
  .tla-sales-item:hover { background:#F8FAFC; }
  .tla-sales-item.selected { background:#EFF6FF; }
  .tla-avatar {
    width:38px; height:38px; border-radius:50%; flex-shrink:0;
    display:flex; align-items:center; justify-content:center;
    font-size:13px; font-weight:700; letter-spacing:0.5px;
  }
  .tla-sales-name { font-size:14px; font-weight:600; color:#0F172A; }
  .tla-sales-email { font-size:12px; color:#94A3B8; font-weight:500; }
  .tla-radio {
    width:20px; height:20px; border-radius:50%; border:2px solid #CBD5E1;
    flex-shrink:0; display:flex; align-items:center; justify-content:center; transition:all 0.15s;
  }
  .tla-radio.checked { border-color:#1E3A8A; background:#1E3A8A; }
  .tla-radio.checked::after { content:''; width:8px; height:8px; border-radius:50%; background:#fff; }

  /* bottom two-col */
  .tla-bottom-grid { display:grid; grid-template-columns:1fr 1fr; gap:24px; margin-bottom:8px; }

  /* stage options */
  .tla-stage-option {
    display:flex; align-items:flex-start; gap:10px;
    padding:10px 12px; border-radius:10px; cursor:pointer;
    transition:background 0.12s; margin-bottom:6px;
  }
  .tla-stage-option:hover { background:#F8FAFC; }
  .tla-stage-radio {
    width:20px; height:20px; border-radius:50%; border:2px solid #CBD5E1;
    flex-shrink:0; display:flex; align-items:center; justify-content:center;
    margin-top:1px; transition:all 0.15s;
  }
  .tla-stage-radio.checked { border-color:#1E3A8A; background:#1E3A8A; }
  .tla-stage-radio.checked::after { content:''; width:8px; height:8px; border-radius:50%; background:#fff; }
  .tla-stage-text-name { font-size:14px; font-weight:600; color:#0F172A; }
  .tla-stage-text-desc { font-size:12px; color:#94A3B8; margin-top:1px; }
  .tla-stage-select {
    width:100%; padding:10px 12px; border:1.5px solid #E2E8F0; border-radius:10px;
    font-family:'DM Sans',sans-serif; font-size:13px; color:#0F172A;
    background:#F8FAFC; outline:none; margin-top:8px; cursor:pointer; transition:border-color 0.15s;
  }
  .tla-stage-select:focus { border-color:#1E40AF; }

  /* advanced toggles */
  .tla-toggle-row {
    display:flex; align-items:flex-start; gap:10px;
    padding:10px 12px; border-radius:10px; cursor:pointer;
    transition:background 0.12s; margin-bottom:6px;
  }
  .tla-toggle-row:hover { background:#F8FAFC; }
  .tla-checkbox {
    width:20px; height:20px; border-radius:6px; border:2px solid #CBD5E1;
    flex-shrink:0; margin-top:1px; display:flex; align-items:center; justify-content:center; transition:all 0.15s;
  }
  .tla-checkbox.checked { border-color:#1E3A8A; background:#1E3A8A; }
  .tla-toggle-name { font-size:14px; font-weight:600; color:#0F172A; }
  .tla-toggle-desc { font-size:12px; color:#94A3B8; margin-top:1px; }

  /* footer */
  .tla-footer {
    padding:16px 28px; border-top:1px solid #F1F3F9;
    display:flex; align-items:center; justify-content:space-between;
    flex-shrink:0; background:#fff;
  }
  .tla-ready-badge {
    display:flex; align-items:center; gap:8px;
    background:#EFF6FF; border:1px solid #BFDBFE;
    padding:8px 14px; border-radius:999px;
    font-size:13px; font-weight:600; color:#1E40AF;
  }
  .tla-footer-btns { display:flex; gap:10px; }
  .tla-btn-close {
    padding:10px 22px; border-radius:10px;
    border:1.5px solid #E2E8F0; background:#fff;
    font-family:'DM Sans',sans-serif; font-size:14px; font-weight:600;
    color:#64748B; cursor:pointer; transition:all 0.15s;
  }
  .tla-btn-close:hover { background:#F8FAFC; border-color:#CBD5E1; color:#0F172A; }
  .tla-btn-assign {
    padding:10px 28px; border-radius:10px; border:none;
    background:#1E3A8A; color:#fff;
    font-family:'DM Sans',sans-serif; font-size:14px; font-weight:700;
    cursor:pointer; transition:all 0.15s; display:flex; align-items:center; gap:8px;
  }
  .tla-btn-assign:hover:not(:disabled) { background:#1E40AF; }
  .tla-btn-assign:disabled { opacity:0.55; cursor:not-allowed; }
  .tla-spinner-sm {
    width:15px; height:15px; border:2px solid rgba(255,255,255,0.3);
    border-top-color:#fff; border-radius:50%; animation:tla-spin 0.7s linear infinite;
  }
  .tla-empty { text-align:center; padding:20px; color:#94A3B8; font-size:13px; }
`;

/* ─── icons ──────────────────────────────────────────────────────────────── */
const IcoClose   = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>;
const IcoSearch  = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>;
const IcoChevron = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="6 9 12 15 18 9"/></svg>;
const IcoCheck   = () => <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3"><polyline points="20 6 9 17 4 12"/></svg>;
const IcoInfo    = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>;
const IcoPeople  = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1E40AF" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>;
const IcoSend    = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>;

/* ════════════════════════════════════════════════════════════════════════════
   COMPONENT
════════════════════════════════════════════════════════════════════════════ */
export const TeamLeaderAssignLeadsDialog = ({ open, onClose, refreshData }) => {
  const dispatch = useDispatch();

  const leadsallRef    = useRef([]);
  const [leadsCount,   setLeadsCount]   = useState(0);
  const [searchQuery,  setSearchQuery]  = useState('');
  const [salesname,    setSalesname]    = useState('');
  const [selectedSale, setSelectedSale] = useState(null);
  const [selectedOption, setSelectedOption] = useState('option1');
  const [selectedStage,  setSelectedStage]  = useState(null);
  const [clearHistory,   setClearHistory]   = useState(false);
  const [sendloading,    setSendloading]    = useState(false);
  const [userlogin,      setUserlogin]      = useState(null);

  // Redux
  const resSalesData  = useSelector(s => s.AllSales.salesforteamleaders?.data || []);
  const resStagesData = useSelector(s => s.Allstages.stage?.data || []);

  // load user + leads on open
  useEffect(() => {
    if (!open) return;
    const u = localStorage.getItem('user');
    if (u) setUserlogin(JSON.parse(u));

    const stored = localStorage.getItem('selectedleedsbyteamleader');
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        leadsallRef.current = parsed;
        setLeadsCount(parsed.length);
      } catch { leadsallRef.current = []; setLeadsCount(0); }
    } else { leadsallRef.current = []; setLeadsCount(0); }

    dispatch(GetAll_stage_Data());
  }, [open]);

  useEffect(() => {
    if (open && userlogin?.data?.email) {
      dispatch(Get_All_Sales_By_TeamLeader_Email_Action(userlogin.data.email));
    }
  }, [open, userlogin?.data?.email]);

  // filtered sales (exclude self)
  const filteredSales = React.useMemo(() => {
    const base = resSalesData.filter(s => s?.userlog?.name !== userlogin?.data?.name);
    const q = searchQuery.toLowerCase();
    return q ? base.filter(s => s.name?.toLowerCase().includes(q) || s.userlog?.email?.toLowerCase().includes(q)) : base;
  }, [resSalesData, userlogin, searchQuery]);

  const handleClose = () => {
    setSalesname(''); setSelectedSale(null);
    setSelectedOption('option1'); setSelectedStage(null);
    setClearHistory(false); setSearchQuery('');
    onClose();
  };

  const handleSubmit = async () => {
    if (!salesname)             return Notify('error', 'Please select a sales person', 'error');
    if (!leadsallRef.current.length) return Notify('error', 'No leads selected', 'error');

    setSendloading(true);
    try {
      const stageValue = selectedOption === 'option2' && selectedStage ? selectedStage : undefined;
      for (const chunk of chunkArray(leadsallRef.current, 10)) {
        await Promise.all(chunk.map(leadId =>
          dispatch(AssignleadsinteamleaderAction(leadId, userlogin?.data?._id, salesname, clearHistory, stageValue))
        ));
      }
      Notify('success', `${leadsallRef.current.length} lead(s) assigned successfully`, 'success');
      localStorage.removeItem('selectedleedsbyteamleader');
      refreshData?.();
      handleClose();
    } catch {
      Notify('error', 'Failed to assign leads', 'error');
    } finally {
      setSendloading(false);
    }
  };

  if (!open) return null;

  return createPortal(
    <>
      <style>{STYLES}</style>
      <div className="tla-overlay" onClick={e => { if (e.target === e.currentTarget) handleClose(); }}>
        <div className="tla-modal">

          {/* ── Header ── */}
          <div className="tla-header">
            <div className="tla-header-top">
              <div>
                <h2 className="tla-title">Assign Leads to Sales</h2>
                <div className="tla-subtitle">
                  <span className="tla-subtitle-dot" />
                  {leadsCount} Lead{leadsCount !== 1 ? 's' : ''} selected — Team Leader Panel
                </div>
              </div>
              <button className="tla-close" onClick={handleClose}><IcoClose /></button>
            </div>
          </div>

          {/* ── Body ── */}
          <div className="tla-body">

            {/* Summary banner */}
            <div className="tla-summary">
              <div className="tla-summary-icon"><IcoPeople /></div>
              <div>
                <div className="tla-summary-count">{leadsCount}</div>
                <div className="tla-summary-label">Leads ready to assign</div>
              </div>
              <div style={{ marginLeft: 'auto', textAlign: 'right' }}>
                <div className="tla-summary-from-label">Assigning from</div>
                <div className="tla-summary-from">{userlogin?.data?.name || 'Team Leader'}</div>
              </div>
            </div>

            {/* Select Sales Person */}
            <p className="tla-section-label">Select Sales Person</p>

            <div className="tla-search-wrap">
              <span className="tla-search-icon"><IcoSearch /></span>
              <input
                className="tla-search-input"
                placeholder="Search sales by name or email…"
                value={searchQuery}
                onChange={e => setSearchQuery(e.target.value)}
              />
              <span className="tla-search-arrow"><IcoChevron /></span>
            </div>

            <div className="tla-sales-list">
              {filteredSales.length === 0 ? (
                <div className="tla-empty">
                  {resSalesData.length === 0 ? 'Loading sales team…' : 'No sales found'}
                </div>
              ) : filteredSales.map(sale => (
                <div
                  key={sale._id}
                  className={`tla-sales-item ${salesname === sale._id ? 'selected' : ''}`}
                  onClick={() => { setSalesname(sale._id); setSelectedSale(sale); }}
                >
                  <div
                    className="tla-avatar"
                    style={{ background: avatarBg(sale.name), color: avatarFg(sale.name) }}
                  >
                    {getInitials(sale.name)}
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div className="tla-sales-name">{sale.name}</div>
                    <div className="tla-sales-email">{sale.userlog?.email || sale.email || '—'}</div>
                  </div>
                  <div className={`tla-radio ${salesname === sale._id ? 'checked' : ''}`} />
                </div>
              ))}
            </div>

            {/* Bottom two-col */}
            <div className="tla-bottom-grid">

              {/* Stage Options */}
              <div>
                <p className="tla-section-label">Stage Options</p>
                <div className="tla-stage-option" onClick={() => setSelectedOption('option1')}>
                  <div className={`tla-stage-radio ${selectedOption === 'option1' ? 'checked' : ''}`} />
                  <div>
                    <div className="tla-stage-text-name">Same Stage</div>
                    <div className="tla-stage-text-desc">Keep current stage</div>
                  </div>
                </div>
                <div className="tla-stage-option" onClick={() => setSelectedOption('option2')}>
                  <div className={`tla-stage-radio ${selectedOption === 'option2' ? 'checked' : ''}`} />
                  <div>
                    <div className="tla-stage-text-name">Change Stage</div>
                    <div className="tla-stage-text-desc">Select new stage</div>
                  </div>
                </div>
                {selectedOption === 'option2' && (
                  <select
                    className="tla-stage-select"
                    value={selectedStage || ''}
                    onChange={e => setSelectedStage(e.target.value || null)}
                  >
                    <option value="">Select Stage</option>
                    {resStagesData
                      .filter(st => st.name?.toLowerCase() !== 'fresh')
                      .map(st => (
                        <option key={st._id} value={st._id}>
                          {st.name === 'No Stage' ? 'Fresh' : st.name}
                        </option>
                      ))}
                  </select>
                )}
              </div>

              {/* Advanced Settings */}
              <div>
                <p className="tla-section-label">Advanced Settings</p>
                <div className="tla-toggle-row" onClick={() => setClearHistory(v => !v)}>
                  <div className={`tla-checkbox ${clearHistory ? 'checked' : ''}`}>
                    {clearHistory && <IcoCheck />}
                  </div>
                  <div>
                    <div className="tla-toggle-name">Clear previous comments</div>
                    <div className="tla-toggle-desc">for this sales person</div>
                  </div>
                </div>
              </div>
            </div>

          </div>{/* /body */}

          {/* ── Footer ── */}
          <div className="tla-footer">
            <div className="tla-ready-badge">
              <IcoInfo />
              READY TO ASSIGN {leadsCount} LEAD{leadsCount !== 1 ? 'S' : ''}
            </div>
            <div className="tla-footer-btns">
              <button className="tla-btn-close" onClick={handleClose}>Close</button>
              <button
                className="tla-btn-assign"
                onClick={handleSubmit}
                disabled={sendloading || !salesname || !leadsCount}
              >
                {sendloading
                  ? <><div className="tla-spinner-sm" />Assigning…</>
                  : <><IcoSend />Assign to Sales</>}
              </button>
            </div>
          </div>

        </div>
      </div>
    </>,
    document.body
  );
};
